import React, { useEffect } from 'react';
import {
  isIOS,
  isIOS13,
  isMobileSafari,
  isMacOs,
  isIPad13,
  isIPhone13,
} from 'react-device-detect';

import { APPSTORE_DOWNLOAD_URL, PLAYSTORE_DOWNLOAD_URL } from 'util/constants';

const isIphone =
  isIOS || isIOS13 || isMobileSafari || isMacOs || isIPad13 || isIPhone13;

export const DownloadAppPage: React.FC = () => {
  useEffect(() => {
    window.location.replace(
      isIphone ? APPSTORE_DOWNLOAD_URL : PLAYSTORE_DOWNLOAD_URL
    );
  });

  return null;
};
